<template>
  <div class="detail">
    <div class="head-dec"></div>
    <div class="book box un-tran">
      <div class="des-top">
        <img class="cover" id="bookImg" @click="goTo"/>
        <div class="info">
          <div class="title">{{ book.title }}</div>
          <div class="row">作者：{{ book.creator }}</div>
          <div class="row">版本：{{ book.edition }}</div>
          <!-- <div class="row">作者：某某某</div> -->
          <div class="row">关键词：{{ book.keyword }}</div>
        </div>
      </div>
      <div class="des-bottom">
        <div class="title">摘要</div>
        <div class="abstract">
          {{ book.summary }}
        </div>
      </div>
    </div>
    <div class="knowledge-base box">
      <div class="part-title">&diams;<span class="inline-title">目录</span></div>
      <div class="rela-list">
        <div class="left-index">
          <div class="item" v-for="item in structures" :class="{active:curVolume === item.volumeName }" @click="changeVolume(item)" :key="item.volumeName">
            <div class="title" :title="item.volumeTitle">{{ item.volumeTitle }}</div>
            <!-- <div class="value">{{ item.num }}</div> -->
          </div>
        </div>
        <div class="right-content">
          <div class="article-con un-tran">
            <article-com v-for="record in records" :record="record" :bookInfo='initBook' :key="record.id" :fileNumber="curVolumeFileNumber">
            </article-com>
          </div>
          <div class="bottom-tools">
            <div class="icon first-page" @click="curPage = 1"></div>
            <div class="icon pre" @click="curPage -= 1"></div>
            <div class="pager"><el-input v-model="curPage" style="width: 70px"></el-input>&nbsp;/&nbsp;{{ pages }}</div>
            <div class="icon next" @click="curPage += 1"></div>
            <div class="icon last-page" @click="curPage = pages"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSearchParams, getBase64FromSinglePDF } from '@/utils'
import api from '@/api'
import userActionsApi from '@/api/userActions.js'
import articleCom from './articleCom'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      curPage: 1,
      pages: 10,
      pageSize: 7,
      bookId: getSearchParams(window.location.href).bookId,
      initBook: {},
      curVolume: '',
      curVolumeFileNumber: 10,
      originInfos: {},
      structures: [],
      records: []
    }
  },
  components: {
    articleCom
  },
  computed: {
    ...mapGetters(['isTra', 'library']),
    book () {
      return this.isTra ? this.originInfos : this.initBook
    }
  },
  methods: {
    goTo () {
      userActionsApi.addUserAction({
        actionCode: 'resourceRead',
        bookId: this.bookId,
        resourceId: this.initBook.id,
        resourceInfos: JSON.stringify(this.initBook),
        resourceCategory: 'bookMetaData',
        terminalType: this.$isPhone ? 'mobile' : 'pc'
      })
      let url = window.location.origin + window.location.pathname
      window.open(url + `#/book${this.$isPhone ? '-mobile' : ''}?bookId=${this.bookId}&page=1&volumeName=${this.curVolume}&fileNumber=${this.curVolumeFileNumber}`)
    },
    async getBook () {
      let res = await api.bookSearch({
        pageIndex: 1,
        pageSize: 1,
        bookId: this.bookId
      })
      this.initBook = res.rows[0]
      this.originInfos = JSON.parse(res.rows[0].originInfos)
      await this.initImg()
      await this.getStructures()
    },
    async getStructures () {
      let res = await api.getStructures({
        pageSize: 999,
        pageIndex: 1,
        bookId: this.bookId
      })
      this.structures = res.rows
      this.changeVolume(res.rows[0])
    },
    async getVolumeData () {
      let res = await api.getVolumeData({
        pageIndex: this.curPage,
        pageSize: this.pageSize,
        bookId: this.bookId,
        volumeName: this.curVolume
      })
      this.records = res.rows
      this.pages = Math.ceil(res.count / this.pageSize)
    },
    async initImg () {
      let bookFilePath = process.env.NODE_ENV === 'production' ? this.library.bookFilePath : 'http://localhost:8047/book'
      let src = await getBase64FromSinglePDF(`${bookFilePath}/pdf/${this.bookId}/0001/0001.pdf`)
      document.getElementById('bookImg').setAttribute('src', src)
    },
    changeVolume (item) {
      this.curPage = 1
      this.curVolume = item.volumeName
      this.curVolumeFileNumber = item.fileNumber
      this.getVolumeData()
    }
  },
  async mounted () {
    await this.getBook()
  },
  watch: {
    curPage (val) {
      if (val < 1 || val > this.pages) return
      this.getVolumeData()
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
// @media screen and (min-width: 769px) {
  @import "./detail-web.less";
// }
// @media screen and (max-width: 768px) {
//   @import "./detail-mobile.less";
// }
</style>
